import script from "./RoleRequiredWeekly.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredWeekly.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredWeekly.vue?vue&type=style&index=0&id=204db06c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204db06c"]])

export default __exports__